import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

/**
 * 注册storeModule
 * @param {Object} store
 * @param {Object} modules
 */
const registerModules = function registerModules(store, modules) {
  if (store && modules) {
    // eslint-disable-next-line no-underscore-dangle
    if (!store._modulesCount) {
      // eslint-disable-next-line no-param-reassign,no-underscore-dangle
      store._modulesCount = {};
    }
    Object.keys(modules).forEach((name) => {
      // eslint-disable-next-line no-underscore-dangle
      if (store._modulesCount[name] > 0) {
        // eslint-disable-next-line no-param-reassign,no-underscore-dangle
        store._modulesCount[name] += 1;
      } else {
        store.registerModule(name, modules[name], { preserveState: !!store.state[name] });
        // eslint-disable-next-line no-param-reassign,no-underscore-dangle
        store._modulesCount[name] = 1;
      }
    });
  }
};

/**
 * 卸载storeModule
 * @param {Object} store
 * @param {Object} modules
 */
const unregisterModule = function unregisterModule(store, modules) {
  if (store && modules) {
    // eslint-disable-next-line no-underscore-dangle
    if (!store._modulesCount) {
      // eslint-disable-next-line no-param-reassign,no-underscore-dangle
      store._modulesCount = {};
    }
    Object.keys(modules).forEach((name) => {
      // eslint-disable-next-line no-underscore-dangle
      if (store._modulesCount[name] > 0) {
        // eslint-disable-next-line no-param-reassign,no-underscore-dangle
        store._modulesCount[name] -= 1;
      }
      // eslint-disable-next-line no-underscore-dangle
      if (store._modulesCount[name] === 0) {
        store.unregisterModule(name);
        // eslint-disable-next-line no-param-reassign,no-underscore-dangle
        delete store._modulesCount[name];
      }
    });
  }
};

/**
 * 遍历components注册storeModule
 * @param {Object} store
 * @param {Object} component
 */
const registerAllModules = function registerAllModules(store, component) {
  registerModules(store, component.storeModules);
  if (component.components) {
    Object.keys(component.components).forEach((name) => {
      if (typeof component.components[name] !== 'function') {
        registerAllModules(store, component.components[name]);
      }
    });
  }
};

/**
 * 遍历component卸载storeModule
 * @param {Object} store
 * @param {Object} component
 */
const unregisterAllModules = function unregisterAllModules(store, component) {
  unregisterModule(store, component.storeModules);
  if (component.components) {
    Object.keys(component.components).forEach((name) => {
      if (typeof component.components[name] !== 'function') {
        unregisterAllModules(store, component.components[name]);
      }
    });
  }
};

const registerModuleOnce = function registerModuleOnce(store, ...args) {
  const moduleName = args[0];
  if (!(store.state && store.state[moduleName])) {
    store.registerModule(...args);
  }
};

/**
 * 创建Store对象，并自动注册和卸载storeModule
 * @returns {Object}
 */
// eslint-disable-next-line import/prefer-default-export
export const createStore = function createStore() {
  const options = {
    state,
    getters,
    actions,
    mutations,
    plugins: [],
  };
  const store = new Vuex.Store(options);
  store.registerAllModules = (component) => {
    registerAllModules(store, component);
    return store;
  };
  store.unregisterAllModules = (component) => {
    unregisterAllModules(store, component);
    return store;
  };
  store.registerModules = (components) => {
    registerModules(store, components);
  };
  store.unregisterModules = (components) => {
    unregisterModule(store, components);
  };
  store.registerModuleOnce = (...args) => {
    registerModuleOnce(store, ...args);
  };
  return store;
};

export default createStore();
